module.exports = __webpack_public_path__ + "img/icon-label2.c12a5f01.svg";